import { z } from 'zod';
import { isValidPhone } from './utils';
import { CommentStatus, SortBy, ShapeType, QuestionShowType } from './types';
import _ from 'lodash';

const Target = z.object({
  target_id: z.string().min(1, { message: 'Không được để trống' }),
});

const Status = z.object({
  status: z.nativeEnum(CommentStatus),
});

const Customer = z.object({
  name: z.string().min(1, { message: 'Không được để trống' }).max(256),
  email: z.string().email({ message: 'Định dạng không đúng' }).max(256),
  phone: z
    .string()
    .min(0)
    .max(256)
    .refine(
      value => {
        if (value.length > 0) {
          if (isValidPhone(value)) return true;
          return false;
        }
        return true;
      },
      { message: 'Số điện thoại không đúng' },
    ),
});

const Base = Customer.merge(Target)
  .merge(Status)
  .extend({
    desc: z.string().min(1, { message: 'Không được để trống' }).max(512),
  });

export const Review = Base.extend({
  amount: z
    .number()
    .positive({ message: 'Vui lòng chọn đánh giá' })
    .int()
    .max(5),
  title: z.string().min(1).max(256).nullable(),
  youtube: z
    .string()
    .max(256)
    .nullable()
    .refine(
      value => {
        if (_.isNull(value)) return true;
        if (_.isString(value) && value.indexOf('youtube.com/watch?v=') !== -1) {
          return true;
        }
        return false;
      },
      { message: 'Link youtube không đúng' },
    ),
  images: z
    .array(
      z.object({
        imageId: z.string().min(1).nullable(),
        src: z.string().min(1),
      }),
    )
    .max(5),
});

export type ReviewPayload = z.infer<typeof Review>;

export const Question = Base;

export type QuestionPayload = z.infer<typeof Question>;

export const Reply = Base;

export type ReplyPayload = z.infer<typeof Reply>;

const ListReview = z.object({
  page: z.number().int().positive(),
  limit: z.number().int().positive().max(50),
  sort_by: z.nativeEnum(SortBy),
  amount: z.number().positive().nullable(),
  target_id: z.string().min(1).nullable(),
  status: z.nativeEnum(CommentStatus).nullable(),
});

export type ListReviewPayload = z.infer<typeof ListReview>;

export const ListQuestion = ListReview.omit({ amount: true });

export type ListQuestionPayload = z.infer<typeof ListQuestion>;

export const ListReply = ListQuestion.omit({ target_id: true });

export type ListReplyPayload = z.infer<typeof ListReply>;

export const Theme = z.object({
  requireLogin: z.boolean(),
  reviewTitle: z.string().min(1, { message: 'Không được để trống' }),
  questionTitle: z.string().min(1, { message: 'Không được để trống' }),
  showTitle: z.boolean(),
  showDate: z.boolean(),
  showSort: z.boolean(),
  acceptImage: z.boolean(),
  acceptVideo: z.boolean(),
  acceptQuestion: z.boolean(),
  questionType: z.nativeEnum(QuestionShowType),
  acceptReply: z.boolean(),
  acceptVerifiedBadge: z.boolean(),
  alwaysVerifiedBadge: z.boolean(),
  approveAuto: z.boolean(),
  shapeType: z.nativeEnum(ShapeType),
  colorShape: z.string().min(1, { message: 'Không được để trống' }),
  colorBgShape: z.string().min(1, { message: 'Không được để trống' }),
  colorVerifiedBadge: z.string().min(1, { message: 'Không được để trống' }),
  colorMain: z.string().min(1, { message: 'Không được để trống' }),
});

export type ThemeSetting = z.infer<typeof Theme>;

export const ListCustomer = z.object({
  page: z.number().int().positive(),
  limit: z.number().int().positive().max(50),
});

export type ListCustomerPayload = z.infer<typeof ListCustomer>;
